const conferencia = (state = [], action) => {
  switch (action.type) {
    case 'ADD_CONFERENCE_CLI':
      return [
        ...state,
     {
        type: "ADD_CONFERENCE_CLI",
        idatendimento: action.id,
        idconferencia: action.idconferencia
      }
    ]
      case 'REMOVE_CONFERENCE_CLI':
        return state.filter(conf =>
          parseInt(conf.idconferencia) !== parseInt(action.idconferencia)
         )
      case 'CLEAR_CONFERENCE_CLI':
        return []
    default:
      return state
  }
}

export default conferencia